import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { AutoLoginView } from '../components/auto-login/AutoLoginView';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const SignInPage = lazyWithReload(() => import('src/pages/auth/sign-in'));
const SignUpPage = lazyWithReload(() => import('src/pages/auth/sign-up'));
const VerifyPage = lazyWithReload(() => import('src/pages/auth/verify'));
const ResetPassword = lazyWithReload(() => import('src/pages/auth/reset-password'));
const UpdatePassword = lazyWithReload(() => import('src/pages/auth/update-password'));

const auth = {
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <SignInPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'sign-up',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <SignUpPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'verify',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <VerifyPage />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'reset-password',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <ResetPassword />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'update-password',
      element: (
        <GuestGuard>
          <AuthCenteredLayout>
            <UpdatePassword />
          </AuthCenteredLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'auto-login/:email/:token',
      element: (
        <AuthCenteredLayout>
          <AutoLoginView />
        </AuthCenteredLayout>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [auth],
  },
];
